// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_bb-0";
export var headerCellHover = "_bb-1";
export var readCellContainer = "_bb-2";
export var readCellSlot = "_bb-3";
export var rowHoverCheckbox = "_bb-4";
export var rowUnreadIndicator = "_bb-5";
export var searchHighlight = "_bb-8";
export var supportTicketRow = "_bb-6";
export var unreadIndicator = "_bb-7";